import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorLayout from '../../components/error/ErrorLayout';
import { useAuth } from '../../contexts/AuthContext';

export default function ForbiddenPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  return (
    <ErrorLayout
      code={t('errors.forbidden.code')}
      title={t('errors.forbidden.title')}
      message={
        isAuthenticated ? t('errors.forbidden.messageAuth') : t('errors.forbidden.messageNoAuth')
      }
      icon="shield"
    >
      <div className="error-actions">
        {isAuthenticated ? (
          <>
            <Link to="/v4" className="btn btn-primary">
              {t('errors.forbidden.dashboard')}
            </Link>
            <button className="btn btn-secondary" onClick={() => navigate(-1)}>
              {t('errors.forbidden.previousPage')}
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="btn btn-primary">
              {t('errors.forbidden.signIn')}
            </Link>
            <Link to="/register" className="btn btn-secondary">
              {t('errors.forbidden.createAccount')}
            </Link>
          </>
        )}
      </div>

      {isAuthenticated && user?.subscriptionTier === 'free' && (
        <div className="error-upgrade">
          <p>
            {t('errors.forbidden.premiumRequired')}{' '}
            <Link to="/upgrade">{t('errors.forbidden.discoverOffers')}</Link>
          </p>
        </div>
      )}
    </ErrorLayout>
  );
}
